import axios from "axios";
import { parseSync, stringify } from "svgson";
import { defaultLogo } from "../page/ThirdScreen/qrSettings/logotypeQr/svg";
import { scanImageData } from "@undecaf/zbar-wasm";
import { getSerializedSVGwithAnyLogo } from "./helpers";

export const getBase64Logo = async (logotypeId) => {
  const logoObj = defaultLogo.find((logo) => logo.id === logotypeId);
  if (!logoObj) {
    return null;
  }
  const { data } = await axios(logoObj.img);
  const svgJson = parseSync(data);
  const serializedSvg = stringify(svgJson);
  const base64Data = window.btoa(serializedSvg);
  return `data:image/svg+xml;base64,${base64Data}`;
};

export const getSerializedSVGwithSvgLogo = (serializedSVG, qrImgElement) => {
  const base64SVG = qrImgElement.getAttribute("href");
  const svgParsed = parseSync(window.atob(base64SVG.split(",")[1]));
  ["x", "y", "width", "height"].forEach((attr) => {
    svgParsed.attributes[attr] = qrImgElement.getAttribute(attr);
  });
  return serializedSVG.replace(/<image([^>]*)\/>/g, stringify(svgParsed));
};

export const getReadabilityInfo = async (svgWrapperRef) => {
  let serializedSVG = new XMLSerializer().serializeToString(
    svgWrapperRef.current
  );
  const qrWithLogo = svgWrapperRef.current.querySelector(
    'image[href^="data:image"]'
  );
  if (qrWithLogo) {
    serializedSVG = qrWithLogo
      .getAttribute("href")
      .startsWith("data:image/svg+xml")
      ? getSerializedSVGwithSvgLogo(serializedSVG, qrWithLogo)
      : getSerializedSVGwithAnyLogo(serializedSVG);
  }
  const base64Data = window.btoa(unescape(encodeURIComponent(serializedSVG)));
  const svgUrl = `data:image/svg+xml;base64,${base64Data}`;
  const img = new Image();
  img.src = svgUrl;

  await img.decode();

  const canvas = document.createElement("canvas");
  canvas.width = img.width || svgWrapperRef.current?.clientWidth;
  canvas.height = img.height || svgWrapperRef.current?.clientHeight;
  const ctx = canvas.getContext("2d");

  if (!ctx) return;

  ctx.drawImage(img, 0, 0);

  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const symbols = await scanImageData(imageData);
  return symbols[0];
};
